import styled from "styled-components";

export const ThanksWrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ThanksBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  padding: 25px;
  margin: 0 10px;
  text-align: center;
  background-color: ${(props) => props.theme.topElementsColor};
  border-top: 5px solid ${(props) => props.theme.primary};
  svg {
    font-size: 60px;
    color: ${(props) => props.theme.primary};
  }
  h2 {
    margin: 5px 0;
  }
  p {
    margin-bottom: 10px;
  }
`;
